import React, { useEffect, useState } from 'react';
import Menu from 'components/menu';
import { Range } from 'components/ui/form/';
import { useStore } from 'hooks';
import { SettingsService } from 'services';
import { Button } from 'components/ui/form';
import styles from './export-settings.module.scss';

const ExportSettings = () => {
  const { setLoading, setUser } = useStore();
  const [percentage, setPercentage] = useState(null);
  const settingsService = new SettingsService({ setUser });

  useEffect(() => {
    if (!percentage) {
      (async () => {
        setLoading(true);
        const { exportWagonPercent } = await settingsService.getPercentage();
        setPercentage(exportWagonPercent);
        setLoading(false);
      })();
    }
  }, [percentage, setLoading, settingsService]);

  const saveRange = async () => {
    setLoading(true);
    await settingsService.postPercentage({ exportWagonPercent: percentage });
    setLoading(false);
  };

  return (
    <>
      <div className={styles.menu}>
        <Menu />
      </div>
      <div className={styles.inner}>
        <Range
          label="Процент экспорта"
          onChangeComplete={({ max }) => { setPercentage(max); }}
          initialValue={percentage}
          max={100}
        />
        <Button onClick={saveRange}>Сохранить</Button>
      </div>
    </>
  );
};

export default ExportSettings;
